// Styled components
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { TextField } from '@mui/material/';
import Button from '@mui/material/Button';

export const AuthContainer = styled(Box)(({ theme }) => ({
	maxWidth: '450px',
	paddingBottom: theme.spacing(4),
	paddingTop: theme.spacing(2),
	margin: '0 auto'
}));

export const LoginTitle = styled(Typography)(({ theme }) => ({
	fontWeight: 700,
	marginBottom: theme.spacing(4),
	fontSize: '2rem',
	color: theme.palette.text.primary
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
	marginBottom: theme.spacing(2),
	'& .MuiOutlinedInput-root': {
		borderRadius: theme.shape.borderRadius,
		backgroundColor: theme.palette.background.paper
	}
}));

export const LoginButton = styled(Button)(({ theme }) => ({
	padding: theme.spacing(1.5),
	borderRadius: theme.shape.borderRadius,
	fontWeight: 600,
	textTransform: 'none',
	marginTop: theme.spacing(1),
	marginBottom: theme.spacing(1),
	backgroundColor: theme.palette.primary.main,
	'&:hover': {
		backgroundColor: theme.palette.primary.dark
	}
}));

export const OrDivider = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	margin: theme.spacing(2, 0),
	color: theme.palette.text.secondary,
	'&::before, &::after': {
		content: '""',
		flex: 1,
		borderBottom: `1px solid ${theme.palette.divider}`
	},
	'& > span': {
		margin: theme.spacing(0, 1),
		fontSize: '0.875rem'
	}
}));

export const FooterText = styled(Box)(({ theme }) => ({
	textAlign: 'center',
	itemAlign: 'center',
	marginTop: theme.spacing(2),
	fontSize: '0.875rem',
	color: theme.palette.text.secondary
}));
